import { DESIGNATION_STATUS } from '../resources/designationStatus';

export const getDesignationStatusColor = (status) => {
  switch (status) {
    case DESIGNATION_STATUS.NOT_SUBMITTED:
      return 'inverse';
    case DESIGNATION_STATUS.FORMED:
      return 'primary';
    case DESIGNATION_STATUS.APPROVED:
      return 'info';
    case DESIGNATION_STATUS.TO_BE_SIGNED:
      return 'tertiary';
    case DESIGNATION_STATUS.SIGNED:
      return 'success';
    case DESIGNATION_STATUS.CANCELLED:
      return 'error';
    default:
      return 'inverse';
  }
};